import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocaleService } from '../services/locale.service';
import { ViewportService } from '../services/viewport.service';

@Component({
	selector: 'app-barcode-share',
	templateUrl: './barcode-share.component.html',
	styleUrls: ['./barcode-share.component.scss'],
})
export class BarcodeShareComponent implements OnInit {
	copied: boolean = false;
	searchParams = new URLSearchParams();
	telegramUrl = 'https://telegram.me/share/url?';
	messengerUrl = 'fb-messenger://share?';
	viberUrl = 'viber://forward';
	gmailUrl = 'http://mail.google.com?mailto:?subject=';
	instagram = 'https://www.instagram.com?';
	constructor(
		public dialogRef: MatDialogRef<BarcodeShareComponent>,
		public viewPort: ViewportService,
		public locale: LocaleService,

		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {}

	onClose() {
		this.dialogRef.close(null);
	}

	copyContent() {
		this.copied = true;
		this.showCopyDone();
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = this.data.url;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
	}

	showCopyDone() {
		setTimeout(() => {
			this.copied = false;
		}, 2000);
	}

	share(socialUrl) {
		this.searchParams.set('url', this.data.url);
		let navUrl = socialUrl + this.searchParams;
		return window.open(navUrl, '_blank');
	}

	shareViaViber() {
		this.searchParams.set('text', this.data.url);
		window.open('viber://forward?' + this.searchParams);
	}

	shareViaMessenger() {
		this.searchParams.set('link', this.data.url);
		let navUrl = this.messengerUrl + this.searchParams;
		return window.open(navUrl, '_blank');
	}
}
